type CloseDrawerFn = () => void;

const registry: Record<string, CloseDrawerFn> = {};

export function registerSidebarDrawer(name: string, closeFn: CloseDrawerFn) {
  registry[name] = closeFn;
}

export function closeSiblingDrawers(except: string) {
  for (const name of Object.keys(registry)) {
    if (name !== except) registry[name]();
  }
}
